import { EnrollmentAccountingEmailReminderResponse } from '../../lib/types/models/enrollment/enrollment-accounting-reminder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendEnrollmentAccountingEmailReminder(ids: number[]) {
  return restApiClient
    .url(constructApiUrl(API['enrollment-accountings'].sendEmailReminder.url, null))
    .post<EnrollmentAccountingEmailReminderResponse>({ ids })
}
